<template>
    <div class="mt-[16px] mb-[4px] border border-solid border-uicolor4 rounded-[4px] px-[16px] pt-[8px]" v-if="data">
        <div class="text-emphas font-bold">【{{ useSpeciesName(data.species) }}】{{ data.name }}: {{ data.transcript }}</div>
        <ui-tooltip-function class="relative w-[100%] mt-[8px] top-[8px]" style="display: block !important" ref="tips">
            <div ref="canvas"></div>
            <template #content>
                <div class="p-[8px] leading-[24px]" v-if="view">
                    <div class="font-bold text-emphas text-[16px] mb-[8px]">Exon</div>
                    <div class="flex justify-between">
                        <div class="whitespace-nowrap mr-[8px]">Gene</div>
                        <div class="whitespace-nowrap">{{ view.range.start }} - {{ view.range.end }}</div>
                    </div>
                    <div class="flex justify-between mt-[4px]" v-show="view.ref">
                        <div class="whitespace-nowrap mr-[8px]">Reference</div>
                        <div class="whitespace-nowrap">{{ view.ref }}</div>
                    </div>
                    <div class="flex justify-between mt-[4px]" v-show="view.alt">
                        <div class="whitespace-nowrap mr-[8px]">Alteration</div>
                        <div class="whitespace-nowrap">{{ view.alt }}</div>
                    </div>
                    <div class="flex justify-between mt-[4px]" v-show="view.cds">
                        <div class="whitespace-nowrap mr-[8px]">CDS</div>
                        <div class="whitespace-nowrap">{{ view.cds?.range.start }} - {{ view.cds?.range.end }}</div>
                    </div>
                    <div class="flex justify-between mt-[4px]" v-show="view.codons">
                        <div class="whitespace-nowrap mr-[8px]">Protein</div>
                        <div class="whitespace-nowrap">{{ view.codons?.range.start }} - {{ view.codons?.range.end }}</div>
                    </div>
                </div>
            </template>
        </ui-tooltip-function>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltipFunction } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { tips, canvas } = nodes;
const { data, view } = refs;

//* 组件属性导出
defineExpose({ render: methods.render });
</script>
